"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_bootstrap_1 = require("react-bootstrap");

var classnames_1 = __importDefault(require("classnames"));

var SzSpinner_1 = __importDefault(require("../SzSpinner/SzSpinner"));

require("./SzButton.scss");

function SzButton(props) {
  var loader = props.loader,
      className = props.className,
      icon = props.icon,
      isDisabled = props.isDisabled,
      children = props.children,
      onClick = props.onClick,
      outline = props.outline,
      small = props.small,
      type = props.type;
  var buttonClassName = classnames_1.default('font-family-bold text-primary text-uppercase position-relative overflow-hidden d-flex align-items-center justify-content-center', {
    'sz-btn border-0': !outline,
    'btn btn-outline-secondary border-secondary sz-btn-outline': outline,
    'py-3': !small,
    'pt-2 sz-line-height-small': small
  }, className);
  return react_1.default.createElement(react_bootstrap_1.Button, {
    variant: "secondary",
    onClick: onClick,
    className: buttonClassName,
    disabled: isDisabled,
    type: type
  }, icon && icon, loader ? react_1.default.createElement(SzSpinner_1.default, null) : children);
}

exports.SzButton = SzButton;
exports.default = SzButton;